module.exports = __webpack_public_path__ + "img/swiper_3.0_4_3.1c1b351e.webp";